<div class="modal-header">
	<button class="button white pull-left cancel-button">{{t "common.cancel"}}</button>
	<button class="button green pull-right save-button">{{t "common.done"}}</button>
	<h4>{{t "hazards.alerts.custom.drawRegion"}}</h4>
</div>
<div class="modal-body">
	<div class="region-map google-maps"></div>
</div>
